export default __webpack_public_path__ + "static/media/keyboardArrowRightIcon.8cee54be.svg";